
import { images } from ".";

const tours = [
    {
        id: 1,
        image: images.tour1,
        title: "Yosemite Hiking",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Yosemite Valley",
            tourType: "Guided Trek",
            checkIn: "May 01, 2024",
            checkOut: "May 08, 2024",
            duration: "4 Days",
            person: "1 Person",
            price: 200,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Mountain Lodges",
            transportation: "Included",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Explore the majestic beauty of Yosemite National Park with our guided hiking adventure. Traverse iconic trails, witness towering waterfalls, and camp under star-studded skies. This tour is perfect for nature lovers and adventure seekers looking to reconnect with the wild."
        ],
        highlights: [
            "Guided Mountain Treks",
            "Exploration of Scenic Trails",
            "Learning about Local Wildlife",
            "Overnight Camping Under the Stars",
            "Fitness and Endurance Training"
        ],
        included: [
            "Professional Guide Services",
            "All Camping Equipment",
            "Meals and Snacks",
            "First Aid Support",
            "Transportation to and from Trailhead"
        ],
        excluded: [
            "Personal Trekking Gear",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Acclimatization",
                description: "Arrive at Yosemite Valley and settle into the lodge. The day includes a light acclimatization walk and a welcome orientation with your guides and fellow trekkers.",
                activities: [
                    "Welcome Dinner and Orientation",
                    "Acclimatization Walk",
                    "Introduction to Trekking Guides and Team"
                ]
            },
            {
                day: "Day 2: Begin Trekking",
                description: "Begin your journey through Yosemite’s iconic trails with stops at meadows, granite cliffs, and forested paths. Enjoy lunch with breathtaking views and set up camp by sunset.",
                activities: [
                    "Morning Start from Base Camp",
                    "Scenic Trekking through Forests",
                    "Lunch with a View",
                    "Evening Camp Setup"
                ]
            },
            {
                day: "Day 3: Glacier Point Adventure",
                description: "Push toward Glacier Point for panoramic views of Half Dome and Yosemite Falls. A highlight of the trek followed by a descent back to camp for a group dinner celebration.",
                activities: [
                    "Early Morning Hike to Glacier Point",
                    "Breathtaking Views of Yosemite Valley",
                    "Group Photos and Relaxation",
                    "Descent to Camp",
                    "Celebratory Dinner"
                ]
            },
            {
                day: "Day 4: Return and Departure",
                description: "After breakfast, hike back to Yosemite Valley. Say goodbye to your guides and fellow hikers, with transportation arranged to your next destination or the nearest airport.",
                activities: [
                    "Descent to Base Camp",
                    "Farewell and Departure"
                ]
            }
        ],
        location: {
            description: "Embark on an unforgettable adventure through the iconic Yosemite National Park. Our Yosemite Hiking experience takes you through scenic trails, towering granite cliffs, and crystal-clear rivers. Immerse yourself in the park's awe-inspiring beauty, with its diverse ecosystems, majestic waterfalls, and panoramic vistas. Whether you're an avid hiker or a nature enthusiast, this hike offers something for everyone.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.340689441532!2d-119.574233!3d37.7455701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096f1eeecae5a01%3A0x94f98d0eb5e6f59!2sYosemite%20Valley%2C%20CA%2095379%2C%20USA!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        },
        gallery: [
            images.tour1Gallery1,
            images.tour1Gallery2,
            images.tour1Gallery3,
            images.tour1Gallery4,
            images.tour1Gallery5,
            images.tour1Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour1Review1,
                name: "Michael Anderson",
                date: "November 5, 2024",
                rating: 5,
                content: "Absolutely unforgettable! Yosemite’s trails and views blew me away. The guides were top-notch."
            },
            {
                id: 2,
                image: images.tour1Review2,
                name: "Emily Johnson",
                date: "November 8, 2024",
                rating: 4.9,
                content: "A magical experience! Perfect for outdoor lovers. Everything was well organized and fun."
            }
        ],
    },
    {
        id: 2,
        image: images.tour2,
        title: "Mountain Backpacking",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Rocky Mountain",
            tourType: "Backpacking Adventure",
            checkIn: "June 10, 2024",
            checkOut: "June 17, 2024",
            duration: "5 Days",
            person: "1 Person",
            price: 350,
            minAge: "14 Years",
            maxAge: "60 Years",
            accommodation: "Tented Camps",
            transportation: "Included",
            bestSeason: "Summer and Fall",
        },
        overviews: [
            "Experience the untamed wilderness of the Rocky Mountains with our immersive Mountain Backpacking tour. Designed for those with a passion for the outdoors, this journey takes you deep into alpine trails, past crystal-clear lakes, and across rugged terrains under the guidance of seasoned wilderness experts."
        ],
        highlights: [
            "Multi-day Wilderness Backpacking",
            "Alpine Lake Views",
            "Backcountry Cooking Sessions",
            "Wildlife Tracking and Nature Skills",
            "Camping in Remote Mountain Locations"
        ],
        included: [
            "Expert Wilderness Guides",
            "All Camping Gear",
            "Daily Meals and Snacks",
            "Water Filtration Systems",
            "Transportation to Trailhead"
        ],
        excluded: [
            "Personal Hiking Gear",
            "Travel Insurance",
            "Park Entrance Fees",
            "Laundry Services",
            "Tips for Guides"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Gear Prep",
                description: "Arrive at the trailhead near Rocky Mountain National Park. After meeting the crew and guides, we'll conduct gear checks, safety briefings, and distribute backpacking equipment.",
                activities: [
                    "Meet and Greet with Guides",
                    "Gear Check and Safety Briefing",
                    "Short Warm-Up Hike"
                ]
            },
            {
                day: "Day 2: Into the Wilderness",
                description: "Begin our backpacking journey into the heart of the Rockies. We'll cross streams, climb moderate passes, and set up camp near a secluded alpine lake.",
                activities: [
                    "Scenic Trail Hiking",
                    "Lunch on the Trail",
                    "Camp Setup by Lake",
                    "Campfire Story Session"
                ]
            },
            {
                day: "Day 3: Peak Day",
                description: "Today we hike to a panoramic viewpoint offering breathtaking views of snow-capped peaks. We'll take time for rest, photography, and lunch at elevation before returning to camp.",
                activities: [
                    "Sunrise Trek to Viewpoint",
                    "Group Photo Session",
                    "Mountain Top Picnic",
                    "Return Descent and Rest"
                ]
            },
            {
                day: "Day 4: Wildlife and Reflection",
                description: "Explore a loop trail known for elk sightings and tranquil meadows. The afternoon is reserved for journaling, backcountry skills, and relaxation.",
                activities: [
                    "Wildlife Tracking Hike",
                    "Nature Journaling",
                    "Wilderness Survival Tips",
                    "Campfire Debrief"
                ]
            },
            {
                day: "Day 5: Return and Departure",
                description: "Pack up and head back to the trailhead. Say goodbye to the Rockies and your fellow backpackers before departing for home or the next adventure.",
                activities: [
                    "Early Morning Hike Out",
                    "Farewell Group Photo",
                    "Shuttle to Departure Point"
                ]
            }
        ],
        location: {
            description: "Embark on an exhilarating Mountain Backpacking journey through rugged peaks and remote wilderness. Our Mountain Backpacking adventure guides you through challenging trails, alpine meadows, and high-altitude ridgelines. Experience the thrill of the outdoors as you trek across diverse landscapes, with sweeping vistas and serene, untouched nature. Perfect for seasoned adventurers and those looking to push their limits, this trek is an unforgettable exploration of the mountains.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.661706144226!2d-105.6836386!3d40.3427938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876961af214250d3%3A0x38c0b3f1e0535e60!2sRocky%20Mountain%20National%20Park!5e0!3m2!1sen!2sus!4v1715803654321!5m2!1sen!2sus",
        },
        gallery: [
            images.tour2Gallery1,
            images.tour2Gallery2,
            images.tour2Gallery3,
            images.tour2Gallery4,
            images.tour2Gallery5,
            images.tour2Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour2Review1,
                name: "David Miller",
                date: "August 22, 2024",
                rating: 5,
                content: "Unforgettable experience! The Rocky Mountains are breathtaking and the guides were super helpful and knowledgeable."
            },
            {
                id: 2,
                image: images.tour2Review2,
                name: "Sara Thompson",
                date: "August 25, 2024",
                rating: 4.8,
                content: "A perfect escape into nature. The trek was well-paced and each campsite was stunning!"
            }
        ],
    },
    {
        id: 3,
        image: images.tour3,
        title: "Banff Hiking",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Banff National Park",
            tourType: "Guided Hiking Tour",
            checkIn: "July 15, 2024",
            checkOut: "July 20, 2024",
            duration: "5 Days",
            person: "1 Person",
            price: 500,
            minAge: "10 Years",
            maxAge: "65 Years",
            accommodation: "Mountain Lodges, Campgrounds",
            transportation: "Included",
            bestSeason: "Summer",
        },
        overviews: [
            "Banff Hiking is a guided adventure through some of Canada’s most iconic alpine scenery. From turquoise glacial lakes to majestic mountain passes, this hike offers a perfect balance of natural beauty and trail exploration for outdoor lovers of all skill levels."
        ],
        highlights: [
            "Guided Alpine Hiking",
            "Lakeside Picnics at Moraine Lake",
            "Wildlife Spotting Opportunities",
            "Photography at Scenic Viewpoints",
            "Evening Campfires & Stargazing"
        ],
        included: [
            "Certified Hiking Guide",
            "All Meals and Snacks",
            "Accommodations",
            "Park Passes and Permits",
            "Transportation Within Tour"
        ],
        excluded: [
            "Travel to Banff",
            "Personal Gear and Clothing",
            "Travel Insurance",
            "Optional Excursions",
            "Guide Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Welcome to Banff",
                description: "Arrive in Banff and meet your hiking group and guide. We’ll go over safety, review the itinerary, and enjoy a welcome dinner surrounded by mountain views.",
                activities: [
                    "Group Orientation",
                    "Gear Check & Safety Briefing",
                    "Welcome Dinner"
                ]
            },
            {
                day: "Day 2: Lake Louise to Plain of Six Glaciers",
                description: "Our first hike takes us from the shores of Lake Louise up to the stunning Plain of Six Glaciers trail. Enjoy lunch surrounded by mountain peaks.",
                activities: [
                    "Lake Louise Trail Hike",
                    "Lunch at Glacial Viewpoint",
                    "Photography and Wildlife Spotting"
                ]
            },
            {
                day: "Day 3: Moraine Lake & Larch Valley",
                description: "We head to Moraine Lake to trek through the beautiful Larch Valley, with views of the Ten Peaks. Campfire activities in the evening.",
                activities: [
                    "Morning Hike through Larch Valley",
                    "Panoramic Mountain Views",
                    "Evening Campfire and Stories"
                ]
            },
            {
                day: "Day 4: Tunnel Mountain & Relaxation",
                description: "Enjoy a moderate hike up Tunnel Mountain, then spend the afternoon exploring Banff town or soaking in the Upper Hot Springs.",
                activities: [
                    "Tunnel Mountain Trail",
                    "Leisure Time in Banff",
                    "Optional Hot Springs Visit"
                ]
            },
            {
                day: "Day 5: Farewell and Departure",
                description: "Wrap up your hiking adventure with a final breakfast and farewell. Depart with new memories, photos, and friendships.",
                activities: [
                    "Group Breakfast",
                    "Departure and Transfer Services"
                ]
            }
        ],
        location: {
            description: "Discover the breathtaking beauty of Banff National Park on a memorable hiking journey. Our Banff Hiking experience takes you through pristine alpine forests, crystal-clear lakes, and towering mountain peaks. Explore some of the most stunning landscapes in the Canadian Rockies, where turquoise waters and dramatic scenery await at every turn. Whether you're a seasoned hiker or a nature lover, Banff offers unparalleled adventure and tranquility in one of the world's most iconic parks.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102397.82925626156!2d-115.6764607!3d51.4968466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5378d4a54b5b3d91%3A0xa67d2f624eb18232!2sBanff%20National%20Park!5e0!3m2!1sen!2sca!4v1715804200000!5m2!1sen!2sca",
        },
        gallery: [
            images.tour3Gallery1,
            images.tour3Gallery2,
            images.tour3Gallery3,
            images.tour3Gallery4,
            images.tour3Gallery5,
            images.tour3Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour3Review1,
                name: "Laura Mitchell",
                date: "September 10, 2024",
                rating: 5,
                content: "One of the most beautiful hiking experiences I’ve ever had! Banff is a dream come true."
            },
            {
                id: 2,
                image: images.tour3Review2,
                name: "James Parker",
                date: "September 12, 2024",
                rating: 4.9,
                content: "The trails, the guides, the scenery – all top-notch. Highly recommended for anyone who loves hiking."
            }
        ],
    },
    {
        id: 4,
        image: images.tour4,
        title: "Torres Trekking",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Torres del Paine",
            tourType: "Guided Multi-Day Trek",
            checkIn: "November 10, 2024",
            checkOut: "November 18, 2024",
            duration: "7 Days",
            person: "1 Person",
            price: 900,
            minAge: "14 Years",
            maxAge: "60 Years",
            accommodation: "Eco-Lodges, Refugios, Tented Camps",
            transportation: "Included",
            bestSeason: "Spring and Summer",
        },
        overviews: [
            "Torres Trekking offers an unforgettable journey through Chile’s most spectacular national park. This multi-day guided trek lets you explore dramatic peaks, turquoise lakes, hanging glaciers, and the famous granite towers of Torres del Paine."
        ],
        highlights: [
            "Scenic W and O Circuit Trails",
            "Hike to the Base of the Towers",
            "Views of Grey Glacier",
            "Sunrise over the Paine Massif",
            "Local Wildlife and Bird Watching"
        ],
        included: [
            "Experienced Trekking Guide",
            "Park Entry Fees",
            "All Meals During Trek",
            "Lodging in Refugios or Eco-Camps",
            "Transportation from Puerto Natales"
        ],
        excluded: [
            "Flights to Chile",
            "Personal Gear and Equipment",
            "Travel Insurance",
            "Snacks and Drinks Outside Meals",
            "Tips for Guides"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival in Puerto Natales",
                description: "Arrive in Puerto Natales and meet your guide and group. Attend a welcome briefing and prepare for the adventure ahead.",
                activities: [
                    "Welcome Briefing and Gear Check",
                    "Dinner with the Group"
                ]
            },
            {
                day: "Day 2: Torres del Paine National Park",
                description: "Drive to the park and start your trek toward the famous Towers viewpoint. Spend the night in a nearby Refugio.",
                activities: [
                    "Drive to Torres del Paine",
                    "Hike to Base of the Towers",
                    "Overnight in Refugio"
                ]
            },
            {
                day: "Day 3: Lago Nordenskjöld",
                description: "Trek alongside Lake Nordenskjöld, capturing views of the Cuernos (horns) and wild guanacos along the way.",
                activities: [
                    "Hiking Alongside the Lake",
                    "Picnic Lunch and Photo Stops",
                    "Evening at Eco-Lodge"
                ]
            },
            {
                day: "Day 4: French Valley Exploration",
                description: "Explore the dramatic French Valley, surrounded by hanging glaciers and vertical rock walls.",
                activities: [
                    "French Valley Trek",
                    "Sightseeing and Wildlife Observation"
                ]
            },
            {
                day: "Day 5: Paine Grande to Grey Glacier",
                description: "Continue the trek toward Grey Glacier, with views of icebergs and distant mountains.",
                activities: [
                    "Trek to Grey Glacier Viewpoint",
                    "Optional Kayaking or Boat Ride"
                ]
            },
            {
                day: "Day 6: Return and Relaxation",
                description: "Begin the return trek back through scenic trails. Enjoy a farewell dinner in the evening.",
                activities: [
                    "Final Hike",
                    "Farewell Dinner and Group Sharing"
                ]
            },
            {
                day: "Day 7: Departure from Puerto Natales",
                description: "Transfer back to Puerto Natales for your onward journey.",
                activities: [
                    "Transfer to Puerto Natales",
                    "End of Tour"
                ]
            }
        ],
        location: {
            description: "Embark on a thrilling adventure through the iconic Torres del Paine National Park with our Torres Trekking experience. This trek takes you through dramatic landscapes, from towering granite spires to windswept plains and vibrant turquoise lakes. Encounter diverse wildlife, explore lush forests, and take in some of the most awe-inspiring views in Patagonia. Perfect for those seeking a challenging yet rewarding journey, Torres Trekking offers an unforgettable experience in one of the world’s most pristine wilderness areas.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d802692.723936144!2d-73.3805186!3d-50.9423016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xbc4d93e332f1e7a7%3A0x46272f8986cb8f2b!2sTorres%20del%20Paine%20National%20Park!5e0!3m2!1sen!2scl!4v1715804720000!5m2!1sen!2scl",
        },
        gallery: [
            images.tour4Gallery1,
            images.tour4Gallery2,
            images.tour4Gallery3,
            images.tour4Gallery4,
            images.tour4Gallery5,
            images.tour4Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour4Review1,
                name: "Carlos Ramirez",
                date: "December 2, 2024",
                rating: 5,
                content: "The views were mind-blowing and the guides were incredibly knowledgeable. Definitely a bucket-list trip!"
            },
            {
                id: 2,
                image: images.tour4Review2,
                name: "Sophie Wallace",
                date: "December 5, 2024",
                rating: 4.8,
                content: "A physically challenging but spiritually rewarding experience. Loved every moment of it!"
            }
        ],
    },
    {
        id: 5,
        image: images.tour5,
        title: "Kilimanjaro Summit",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Mount Kilimanjaro",
            tourType: "Guided Ascent",
            checkIn: "January 05, 2025",
            checkOut: "January 13, 2025",
            duration: "8 Days",
            person: "1 Person",
            price: 1500,
            minAge: "16 Years",
            maxAge: "65 Years",
            accommodation: "Tented Camps, Mountain Huts",
            transportation: "Included",
            bestSeason: "January to March, June to October",
        },
        overviews: [
            "Kilimanjaro Summit is a once-in-a-lifetime trekking experience to the highest peak in Africa. This guided expedition takes you through diverse ecosystems, from rainforest to alpine desert, and up to Uhuru Peak at 5,895 meters above sea level."
        ],
        highlights: [
            "Uhuru Peak Summit Experience",
            "Guided Ascent via Marangu Route",
            "Trekking through 5 Climate Zones",
            "Incredible Sunrise Views from the Summit",
            "Cultural Interactions with Local Porters"
        ],
        included: [
            "Professional Mountain Guide",
            "All Park Fees and Permits",
            "Accommodation During Trek",
            "All Meals on the Mountain",
            "Airport Transfers and Ground Transport"
        ],
        excluded: [
            "International Flights",
            "Climbing Gear Rental",
            "Tips for Guides and Porters",
            "Travel Insurance",
            "Vaccinations and Medical Expenses"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival in Moshi",
                description: "Arrive at Kilimanjaro International Airport and transfer to Moshi town for a pre-climb briefing and gear check.",
                activities: [
                    "Airport Transfer",
                    "Welcome Dinner",
                    "Trek Preparation and Briefing"
                ]
            },
            {
                day: "Day 2: Moshi to Mandara Hut",
                description: "Begin your trek from Marangu Gate through tropical rainforest to Mandara Hut.",
                activities: [
                    "Drive to Marangu Gate",
                    "Trek through Rainforest",
                    "Overnight at Mandara Hut"
                ]
            },
            {
                day: "Day 3: Mandara to Horombo Hut",
                description: "Hike through moorland terrain and enjoy views of Mawenzi and Kibo peaks.",
                activities: [
                    "Trek to Horombo Hut",
                    "Altitude Adjustment Breaks",
                    "Rest and Acclimatization"
                ]
            },
            {
                day: "Day 4: Acclimatization Day",
                description: "Spend an extra day at Horombo Hut for acclimatization, with optional short hikes.",
                activities: [
                    "Optional Hike to Zebra Rocks",
                    "Rest and Hydration",
                    "Acclimatization Briefing"
                ]
            },
            {
                day: "Day 5: Horombo to Kibo Hut",
                description: "Ascend through the alpine desert to Kibo Hut in preparation for the summit attempt.",
                activities: [
                    "Alpine Desert Trek",
                    "Dinner and Early Sleep at Kibo"
                ]
            },
            {
                day: "Day 6: Summit Day",
                description: "Start your summit push around midnight and reach Uhuru Peak at sunrise. Descend back to Horombo Hut.",
                activities: [
                    "Midnight Summit Attempt",
                    "Uhuru Peak Sunrise",
                    "Descent to Horombo Hut"
                ]
            },
            {
                day: "Day 7: Return to Moshi",
                description: "Complete your descent to the base and transfer back to Moshi for a well-earned celebration.",
                activities: [
                    "Descent to Marangu Gate",
                    "Certificate Presentation",
                    "Drive to Moshi"
                ]
            },
            {
                day: "Day 8: Departure",
                description: "After breakfast, transfer to the airport for your onward journey.",
                activities: [
                    "Breakfast and Check-Out",
                    "Airport Drop-Off"
                ]
            }
        ],
        location: {
            description: "Embark on the ultimate adventure to reach the summit of Mount Kilimanjaro, Africa's highest peak. The Kilimanjaro Summit trek offers an incredible journey through diverse ecosystems, from lush rainforests to alpine deserts, culminating in a breathtaking view from the summit. Experience the thrill of conquering one of the Seven Summits, with its unique combination of stunning landscapes and challenging terrain. Ideal for experienced trekkers and those seeking an unforgettable challenge, the Kilimanjaro Summit promises a once-in-a-lifetime achievement.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d315011.9092746883!2d37.3535434!3d-3.0758336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19d7a209f02171df%3A0x7a4c8d5d5ad7be56!2sMount%20Kilimanjaro!5e0!3m2!1sen!2s!4v1715805234567!5m2!1sen!2s",
        },
        gallery: [
            images.tour5Gallery1,
            images.tour5Gallery2,
            images.tour5Gallery3,
            images.tour5Gallery4,
            images.tour5Gallery5,
            images.tour5Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour5Review1,
                name: "James Matiba",
                date: "February 3, 2025",
                rating: 5,
                content: "Unforgettable experience! The summit day was tough but so worth it. Our guides were amazing and very encouraging."
            },
            {
                id: 2,
                image: images.tour5Review2,
                name: "Claire D'Souza",
                date: "February 6, 2025",
                rating: 4.9,
                content: "The scenery, the challenge, and the people made this one of the most rewarding adventures I’ve ever taken."
            }
        ],
    },
    {
        id: 6,
        image: images.tour6,
        title: "Canyoneering Tour",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Zion National Park",
            tourType: "Adventure Canyoneering",
            checkIn: "April 15, 2025",
            checkOut: "April 20, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 850,
            minAge: "14 Years",
            maxAge: "60 Years",
            accommodation: "Lodges, Campgrounds, Hotels",
            transportation: "Included",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Canyoneering Tour in Zion National Park offers an adrenaline-filled adventure through narrow slot canyons, natural rock formations, and hidden pools. This tour blends hiking, rappelling, and climbing in one of the most scenic parks in the United States."
        ],
        highlights: [
            "Rappelling into Deep Canyons",
            "Exploration of Zion’s Slot Canyons",
            "Wading and Swimming Through Hidden Pools",
            "Expert-Led Adventure Activities",
            "Stunning Views and Photo Opportunities"
        ],
        included: [
            "Certified Adventure Guides",
            "All Safety Gear (Helmets, Harnesses, Ropes)",
            "Park Entrance Fees",
            "Meals and Hydration Supplies",
            "Transportation During Tour"
        ],
        excluded: [
            "Travel to Zion National Park",
            "Personal Gear and Clothing",
            "Travel Insurance",
            "Gratuities",
            "Optional Extra Activities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive at Zion National Park and meet your guide team for a detailed safety and itinerary briefing. Enjoy a welcome dinner and get fitted with gear.",
                activities: [
                    "Arrival at Zion",
                    "Gear Check and Orientation",
                    "Welcome Dinner"
                ]
            },
            {
                day: "Day 2: Basic Canyoneering Skills",
                description: "Practice rappelling and rope techniques in a training area to prepare for the canyon adventures ahead.",
                activities: [
                    "Rope Technique Workshop",
                    "Practice Rappels",
                    "Safety Drills"
                ]
            },
            {
                day: "Day 3: First Canyon Descent",
                description: "Embark on your first real descent into one of Zion’s beginner-friendly slot canyons. Expect hikes, scrambles, and short rappels.",
                activities: [
                    "Morning Hike to Canyon",
                    "Canyoneering Adventure",
                    "Evening Campfire"
                ]
            },
            {
                day: "Day 4: Advanced Canyon Challenge",
                description: "Take on a more challenging canyon with longer rappels, narrow passages, and water sections.",
                activities: [
                    "Advanced Canyon Entry",
                    "Technical Rappels and Climbs",
                    "Scenic Photography Stops"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Wrap up your adventure with a farewell breakfast and share highlights from your journey before departing Zion.",
                activities: [
                    "Breakfast and Goodbyes",
                    "Optional Park Exploration",
                    "Departure"
                ]
            }
        ],
        location: {
            description: "Get ready for an adrenaline-pumping adventure with our Canyoneering Tour! Explore narrow canyons, climb waterfalls, and navigate through rugged terrain in a thrilling, action-packed journey. This tour takes you deep into hidden landscapes, where you’ll rappel down cliffs, jump into crystal-clear pools, and slide through natural rock formations. Perfect for thrill-seekers and nature lovers alike, the Canyoneering Tour offers an unforgettable experience of the great outdoors and the excitement of discovery.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506888.3297748932!2d-113.0572867!3d37.1782916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c46a1e72f5e57%3A0x911c79d88e26fc64!2sZion%20National%20Park!5e0!3m2!1sen!2sus!4v1715805700000!5m2!1sen!2sus",
        },
        gallery: [
            images.tour6Gallery1,
            images.tour6Gallery2,
            images.tour6Gallery3,
            images.tour6Gallery4,
            images.tour6Gallery5,
            images.tour6Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour6Review1,
                name: "Sarah Thompson",
                date: "April 25, 2024",
                rating: 5,
                content: "One of the most thrilling outdoor experiences I’ve ever had! The guides were super professional, and the canyons were unreal."
            },
            {
                id: 2,
                image: images.tour6Review2,
                name: "Daniel Cruz",
                date: "April 28, 2024",
                rating: 4.8,
                content: "Zion’s beauty combined with this action-packed tour made for an unforgettable adventure. Highly recommend it!"
            }
        ],
    },
    {
        id: 7,
        image: images.tour7,
        title: "Valley Photography",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Yosemite Valley",
            tourType: "Photography Expedition",
            checkIn: "May 10, 2025",
            checkOut: "May 14, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 950,
            minAge: "16 Years",
            maxAge: "70 Years",
            accommodation: "Lodges, Cabins, Campgrounds",
            transportation: "Included",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Valley Photography is a guided photography tour designed for nature and landscape enthusiasts looking to capture Yosemite’s iconic views. From sunrise shots at Tunnel View to sunset over Half Dome, this experience is tailored for photographers of all levels."
        ],
        highlights: [
            "Golden Hour Shoots",
            "Photo Walks to Iconic Spots",
            "Photography Coaching from Experts",
            "Wildlife and Waterfall Captures",
            "Group Critique and Editing Sessions"
        ],
        included: [
            "Professional Photography Guide",
            "Local Transportation",
            "Lodging in Yosemite Valley",
            "Daily Photo Tours",
            "Editing and Review Workshops"
        ],
        excluded: [
            "Camera Equipment",
            "Meals and Beverages",
            "Park Entrance Fees",
            "Travel Insurance",
            "Personal Expenses"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive in Yosemite Valley, check into accommodations, and meet the group for an orientation session and welcome gathering.",
                activities: [
                    "Check-in and Settle In",
                    "Welcome Meeting",
                    "Evening Shoot at Tunnel View"
                ]
            },
            {
                day: "Day 2: Sunrise to Sunset",
                description: "Full day of guided shoots starting at sunrise. Explore Yosemite Falls, El Capitan, and Valley meadows with expert guidance.",
                activities: [
                    "Sunrise at Glacier Point",
                    "Morning Walk to Yosemite Falls",
                    "El Capitan Viewing",
                    "Evening Sunset Shoot"
                ]
            },
            {
                day: "Day 3: Advanced Composition",
                description: "Focus on creative techniques and composition. Midday editing workshop followed by another golden hour shoot.",
                activities: [
                    "Rule of Thirds and Framing Tips",
                    "Group Editing Session",
                    "Golden Hour Capture at Valley View"
                ]
            },
            {
                day: "Day 4: Waterfalls & Wildlife",
                description: "Track wildlife and explore serene waterfall locations. Night photography for interested participants.",
                activities: [
                    "Wildlife Spotting with Long Lens",
                    "Bridalveil and Vernal Falls",
                    "Optional Night Sky Photography"
                ]
            },
            {
                day: "Day 5: Final Review and Departure",
                description: "Wrap up with a group review of your best shots and receive final tips from the pros before departure.",
                activities: [
                    "Photo Critique and Awards",
                    "Group Breakfast",
                    "Farewell and Checkout"
                ]
            }
        ],
        location: {
            description: "Capture the stunning beauty of nature with our Valley Photography experience. This tour takes you through some of the most picturesque valleys, offering unparalleled opportunities to photograph breathtaking landscapes, vibrant wildlife, and serene vistas. Whether you're a professional photographer or an enthusiast, this experience provides the perfect setting to improve your skills and create unforgettable images of the natural world. From sunrise to sunset, every moment in the valley offers a unique photographic opportunity.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.340689441532!2d-119.574233!3d37.7455701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096f1eeecae5a01%3A0x94f98d0eb5e6f59!2sYosemite%20Valley%2C%20CA%2095379%2C%20USA!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        },
        gallery: [
            images.tour7Gallery1,
            images.tour7Gallery2,
            images.tour7Gallery3,
            images.tour7Gallery4,
            images.tour7Gallery5,
            images.tour7Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour7Review1,
                name: "Olivia Martin",
                date: "May 20, 2024",
                rating: 5,
                content: "Absolutely breathtaking. The guide gave great tips and I captured some of my best photos ever!"
            },
            {
                id: 2,
                image: images.tour7Review2,
                name: "James Patel",
                date: "May 22, 2024",
                rating: 4.9,
                content: "The lighting, locations, and instruction were all top-notch. Highly recommended for photo lovers."
            }
        ],
    },
    {
        id: 8,
        image: images.tour8,
        title: "Scenic Drive",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Rocky Mountain",
            tourType: "Leisure Drive Tour",
            checkIn: "June 10, 2025",
            checkOut: "June 12, 2025",
            duration: "3 Days",
            person: "1 Person",
            price: 420,
            minAge: "10 Years",
            maxAge: "75 Years",
            accommodation: "Lodges, Inns",
            transportation: "Included",
            bestSeason: "Summer and Early Fall",
        },
        overviews: [
            "Scenic Drive is a relaxing and breathtaking tour through the winding roads of Rocky Mountain National Park. Perfect for families and travelers who love nature from the comfort of a vehicle, this drive takes you through alpine meadows, towering peaks, and picturesque overlooks."
        ],
        highlights: [
            "Trail Ridge Road Adventure",
            "Stunning Mountain Overlooks",
            "Alpine Meadows and Wildlife",
            "Photography Stops at Key Points",
            "Relaxed and Comfortable Journey"
        ],
        included: [
            "Private Vehicle and Driver",
            "Professional Tour Guide",
            "Park Entry Fees",
            "2 Nights Accommodation",
            "Bottled Water and Snacks"
        ],
        excluded: [
            "Meals Not Mentioned",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Hiking Trails",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Welcome and Lower Elevation Drive",
                description: "Arrive and begin the tour exploring the lower parts of the park, including Moraine Park and Bear Lake with ample time for scenic stops and wildlife sightings.",
                activities: [
                    "Check-In and Welcome Briefing",
                    "Drive Through Moraine Park",
                    "Evening Views at Bear Lake"
                ]
            },
            {
                day: "Day 2: Trail Ridge Road Exploration",
                description: "Travel the famous Trail Ridge Road, one of the highest paved roads in North America. Stop at overlooks, visitor centers, and picnic spots.",
                activities: [
                    "Trail Ridge Road Scenic Drive",
                    "Visit Alpine Visitor Center",
                    "Lunch at a Scenic Picnic Spot",
                    "Wildlife Viewing Opportunities"
                ]
            },
            {
                day: "Day 3: Short Walks and Departure",
                description: "Optional easy walks or continue the scenic drive through the southern part of the park before concluding the tour.",
                activities: [
                    "Easy Walk at Sprague Lake",
                    "Final Scenic Drive and Photo Stops",
                    "Farewell and Departure"
                ]
            }
        ],
        location: {
            description: "Embark on a leisurely Scenic Drive through some of the most picturesque landscapes. This tour offers the perfect opportunity to enjoy breathtaking views from the comfort of your vehicle, passing through rolling hills, tranquil valleys, and dramatic coastlines. Whether you're seeking a relaxing escape or a photographic adventure, the Scenic Drive provides unforgettable vistas at every turn. Ideal for those who appreciate the beauty of nature from a different perspective, this drive offers a unique way to explore the surroundings.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.661706144226!2d-105.6836386!3d40.3427938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876961af214250d3%3A0x38c0b3f1e0535e60!2sRocky%20Mountain%20National%20Park!5e0!3m2!1sen!2sus!4v1715803654321!5m2!1sen!2sus",
        },
        gallery: [
            images.tour8Gallery1,
            images.tour8Gallery2,
            images.tour8Gallery3,
            images.tour8Gallery4,
            images.tour8Gallery5,
            images.tour8Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour8Review1,
                name: "Sophia Green",
                date: "July 15, 2024",
                rating: 5,
                content: "A peaceful and scenic journey through one of the most beautiful parks I've ever visited. Highly recommended!"
            },
            {
                id: 2,
                image: images.tour8Review2,
                name: "Daniel Lewis",
                date: "July 18, 2024",
                rating: 4.8,
                content: "The guide was knowledgeable and friendly. Loved every minute of the drive and the incredible views."
            }
        ],
    },
    {
        id: 9,
        image: images.tour9,
        title: "Park Photography",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Banff National Park",
            tourType: "Photography Tour",
            checkIn: "August 05, 2025",
            checkOut: "August 10, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 850,
            minAge: "15 Years",
            maxAge: "70 Years",
            accommodation: "Lodges, Cabins",
            transportation: "Included",
            bestSeason: "Summer and Fall",
        },
        overviews: [
            "Park Photography is a visual journey through the iconic landscapes of Banff National Park. This tour is tailored for photography enthusiasts of all levels, offering expert guidance to capture the stunning lakes, mountains, and wildlife that define this Canadian treasure."
        ],
        highlights: [
            "Guided Photography Sessions",
            "Sunrise at Moraine Lake",
            "Sunset Over Lake Louise",
            "Wildlife Spotting and Photography",
            "Hands-On Landscape Photography Workshops"
        ],
        included: [
            "Photography Guide and Mentorship",
            "Transportation Throughout the Park",
            "Park Entry Pass",
            "Lodging for 5 Nights",
            "Snacks and Water"
        ],
        excluded: [
            "Photography Equipment",
            "Meals Not Listed",
            "Travel Insurance",
            "Personal Expenses",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Settle into your accommodation and meet your photography guide. Get an overview of the schedule and photography tips for the tour.",
                activities: [
                    "Arrival at Banff",
                    "Photography Orientation Session",
                    "Welcome Reception"
                ]
            },
            {
                day: "Day 2: Sunrise at Moraine Lake",
                description: "Capture the first light hitting the iconic peaks of Moraine Lake. Explore nearby trails for unique landscape perspectives.",
                activities: [
                    "Early Morning Sunrise Shoot",
                    "Photography Walk Around Moraine Lake",
                    "Editing Session in the Evening"
                ]
            },
            {
                day: "Day 3: Wildlife and Forests",
                description: "Spend the day photographing elk, deer, and other wildlife in their natural habitat. Learn techniques for wildlife photography.",
                activities: [
                    "Wildlife Spotting Tour",
                    "Tips for Shooting Moving Subjects",
                    "Evening Campfire Chat"
                ]
            },
            {
                day: "Day 4: Lake Louise Sunset",
                description: "Enjoy a relaxed morning followed by an afternoon hike and a golden-hour photo session at Lake Louise.",
                activities: [
                    "Light Hike to Lake Louise Overlook",
                    "Sunset Photography at Lake Louise",
                    "Night Sky Photo Option (Weather Permitting)"
                ]
            },
            {
                day: "Day 5: Final Edits and Departure",
                description: "Wrap up the tour with a photo showcase session, peer feedback, and final goodbyes.",
                activities: [
                    "Editing and Sharing Final Shots",
                    "Group Feedback and Highlights",
                    "Farewell and Departure"
                ]
            }
        ],
        location: {
            description: "Immerse yourself in nature's wonders with our Park Photography experience. This tour takes you through stunning parks, where you can capture the natural beauty of lush forests, wildlife, and vibrant landscapes. Whether you're an aspiring photographer or a seasoned pro, the park offers endless opportunities to shoot incredible moments, from majestic sunsets to peaceful reflections in tranquil lakes. Explore the park’s diverse ecosystems and enhance your photography skills while creating breathtaking images of the great outdoors.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102397.82925626156!2d-115.6764607!3d51.4968466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5378d4a54b5b3d91%3A0xa67d2f624eb18232!2sBanff%20National%20Park!5e0!3m2!1sen!2sca!4v1715804200000!5m2!1sen!2sca",
        },
        gallery: [
            images.tour9Gallery1,
            images.tour9Gallery2,
            images.tour9Gallery3,
            images.tour9Gallery4,
            images.tour9Gallery5,
            images.tour9Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour9Review1,
                name: "Ava Mitchell",
                date: "September 10, 2024",
                rating: 5,
                content: "Absolutely loved this tour! The photography guide was fantastic, and I came home with some of my best shots ever."
            },
            {
                id: 2,
                image: images.tour9Review2,
                name: "Liam Parker",
                date: "September 12, 2024",
                rating: 4.9,
                content: "Perfect balance of learning and exploration. Banff is stunning, and this tour helped me capture it beautifully."
            }
        ],
    },
    {
        id: 10,
        image: images.tour10,
        title: "Photography Adventure",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Torres del Paine",
            tourType: "Photography Tour",
            checkIn: "December 01, 2025",
            checkOut: "December 07, 2025",
            duration: "6 Days",
            person: "1 Person",
            price: 1200,
            minAge: "16 Years",
            maxAge: "70 Years",
            accommodation: "Eco-Lodges, Campsites",
            transportation: "Included",
            bestSeason: "November to March",
        },
        overviews: [
            "Photography Adventure is an immersive photo expedition through the breathtaking landscapes of Torres del Paine. Capture towering granite peaks, turquoise lakes, and incredible Patagonian wildlife. Whether you're a beginner or seasoned photographer, this adventure offers world-class photo opportunities and expert guidance in the heart of Chilean Patagonia."
        ],
        highlights: [
            "Sunrise and Sunset Shoots",
            "Wildlife Photography (Guanacos, Condors)",
            "Lakes and Glacier Views",
            "Milky Way and Night Sky Photography",
            "Landscape Composition Workshops"
        ],
        included: [
            "Photography Mentor",
            "Accommodation and Park Entry",
            "Transportation Within the Park",
            "Daily Snacks and Beverages",
            "Guided Excursions and Workshops"
        ],
        excluded: [
            "Camera Gear and Accessories",
            "International Airfare",
            "Meals Not Listed",
            "Travel Insurance",
            "Personal Expenses"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Welcome",
                description: "Arrive at Torres del Paine and meet your photography mentor. Enjoy an evening orientation and introductory photography talk.",
                activities: [
                    "Transfer from Airport",
                    "Welcome Session",
                    "First Sunset Shoot"
                ]
            },
            {
                day: "Day 2: Lakes and Mountains",
                description: "Focus on wide landscapes, lakes, and iconic mountain formations like the Cuernos del Paine.",
                activities: [
                    "Sunrise Shoot at Lake Pehoé",
                    "Trekking and Midday Composition Workshop",
                    "Sunset at Cuernos Viewpoint"
                ]
            },
            {
                day: "Day 3: Wildlife and Forests",
                description: "Track and photograph local wildlife in their natural environment with a guide.",
                activities: [
                    "Wildlife Safari (Guanacos, Foxes)",
                    "Telephoto Technique Session",
                    "Afternoon Rest and Image Review"
                ]
            },
            {
                day: "Day 4: Glacier and Ice Fields",
                description: "Capture the surreal beauty of glaciers and floating icebergs near Grey Lake.",
                activities: [
                    "Morning Glacier Boat Tour",
                    "Photography on Ice Field Trails",
                    "Sunset Reflection Shoot"
                ]
            },
            {
                day: "Day 5: Night Sky and Editing",
                description: "Experience astro photography and fine-tune your editing skills with expert feedback.",
                activities: [
                    "Editing and Workflow Class",
                    "Optional Hike to Hidden Falls",
                    "Milky Way and Night Sky Shoot"
                ]
            },
            {
                day: "Day 6: Final Showcase and Departure",
                description: "Wrap up with a final portfolio review, participant showcase, and farewell lunch.",
                activities: [
                    "Portfolio Showcase",
                    "Group Critique Session",
                    "Farewell Lunch and Departure"
                ]
            }
        ],
        location: {
            description: "Set off on a thrilling Photography Adventure that combines the excitement of exploration with the art of capturing nature's finest moments. From towering peaks to tranquil waters, this adventure takes you through diverse landscapes, offering countless opportunities to photograph stunning vistas, wildlife, and hidden gems. Whether you're a novice or an experienced photographer, this adventure will push your creativity and technical skills to new heights, all while immersing you in the beauty of the great outdoors.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d802692.723936144!2d-73.3805186!3d-50.9423016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xbc4d93e332f1e7a7%3A0x46272f8986cb8f2b!2sTorres%20del%20Paine%20National%20Park!5e0!3m2!1sen!2scl!4v1715804720000!5m2!1sen!2scl",
        },
        gallery: [
            images.tour10Gallery1,
            images.tour10Gallery2,
            images.tour10Gallery3,
            images.tour10Gallery4,
            images.tour10Gallery5,
            images.tour10Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour10Review1,
                name: "Daniel Reyes",
                date: "December 15, 2024",
                rating: 5,
                content: "One of the most awe-inspiring photography experiences I’ve ever had. The landscapes and guidance were both top-notch."
            },
            {
                id: 2,
                image: images.tour10Review2,
                name: "Sophia Müller",
                date: "December 17, 2024",
                rating: 4.8,
                content: "Spectacular locations and helpful tips throughout. I learned so much and left with a stunning photo collection."
            }
        ],
    },
    {
        id: 11,
        image: images.tour11,
        title: "Safari Trek",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Mount Kilimanjaro",
            tourType: "Trekking and Safari Tour",
            checkIn: "June 01, 2025",
            checkOut: "June 14, 2025",
            duration: "14 Days",
            person: "1 Person",
            price: 2800,
            minAge: "18 Years",
            maxAge: "65 Years",
            accommodation: "Mountain Huts, Safari Camps",
            transportation: "Included",
            bestSeason: "June to October",
        },
        overviews: [
            "Safari Trek combines the thrill of trekking Mount Kilimanjaro with the excitement of a safari through Tanzania's Serengeti and Ngorongoro Crater. This 14-day adventure takes you from the base of Kilimanjaro to the wildlife-filled plains of the Serengeti. It's perfect for trekkers and wildlife enthusiasts alike."
        ],
        highlights: [
            "Summit Mount Kilimanjaro",
            "Safari in Serengeti National Park",
            "Ngorongoro Crater Wildlife Experience",
            "Trek Through Rainforests and Alpine Meadows",
            "Visit Maasai Villages"
        ],
        included: [
            "Guided Trekking Services",
            "Safari Tour and Guide",
            "All Accommodations and Meals",
            "Transportation to and from Destinations",
            "All Park Fees and Entry Permits"
        ],
        excluded: [
            "Travel Insurance",
            "Personal Gear and Trekking Equipment",
            "Visa Fees",
            "Optional Safari Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival in Tanzania",
                description: "Arrive in Tanzania, where you'll be transferred to a hotel in Moshi for a briefing and preparation.",
                activities: [
                    "Arrival and Transfer to Hotel",
                    "Pre-Trek Briefing",
                    "Evening Dinner and Rest"
                ]
            },
            {
                day: "Day 2-5: Mount Kilimanjaro Trek (Machame Route)",
                description: "Start your ascent of Mount Kilimanjaro. Over the next four days, you'll trek through dense rainforests, alpine meadows, and volcanic landscapes.",
                activities: [
                    "Day 1: Machame Gate to Machame Camp",
                    "Day 2: Machame Camp to Shira Camp",
                    "Day 3: Shira Camp to Barranco Camp",
                    "Day 4: Barranco Camp to Karanga Camp"
                ]
            },
            {
                day: "Day 6: Summit Day",
                description: "Reach the summit of Mount Kilimanjaro. Experience breathtaking views and celebrate your achievement at Uhuru Peak.",
                activities: [
                    "Early Morning Ascent to Summit",
                    "Summit Celebration at Uhuru Peak",
                    "Descent to Mweka Camp"
                ]
            },
            {
                day: "Day 7: Descent and Transfer to Safari",
                description: "Descend the mountain and return to Moshi, where you'll rest and prepare for the next leg of the adventure: a safari.",
                activities: [
                    "Descent to Mweka Gate",
                    "Return to Hotel for Rest",
                    "Safari Preparation Briefing"
                ]
            },
            {
                day: "Day 8-10: Serengeti National Park Safari",
                description: "Begin your safari adventure through the Serengeti, renowned for its vast plains and wildlife. Spot the Big Five and more.",
                activities: [
                    "Morning Game Drive",
                    "Afternoon Safari and Wildlife Viewing",
                    "Cultural Experience with Maasai Tribe"
                ]
            },
            {
                day: "Day 11-12: Ngorongoro Crater Safari",
                description: "Explore the Ngorongoro Crater, one of the most stunning wildlife reserves in Africa. Encounter a diverse range of animals in this natural amphitheater.",
                activities: [
                    "Game Drives in Ngorongoro Crater",
                    "Visit Olduvai Gorge"
                ]
            },
            {
                day: "Day 13: Return to Arusha",
                description: "Return to Arusha, where you'll have time for shopping or relaxation before your departure.",
                activities: [
                    "Transfer Back to Arusha",
                    "Leisure and Souvenir Shopping"
                ]
            },
            {
                day: "Day 14: Departure",
                description: "Bid farewell to Tanzania as you head to the airport for your flight home.",
                activities: [
                    "Final Farewell Breakfast",
                    "Airport Transfer and Departure"
                ]
            }
        ],
        location: {
            description: "Embark on an unforgettable Safari Trek, where adventure meets the wild. Traverse vast savannas, dense jungles, and rugged terrains in search of exotic wildlife and breathtaking landscapes. This trek offers the chance to witness Africa’s majestic animals in their natural habitat, including lions, elephants, and giraffes. Ideal for wildlife enthusiasts and photographers, the Safari Trek is a thrilling journey that combines the excitement of discovery with the beauty of nature.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d315011.9092746883!2d37.3535434!3d-3.0758336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19d7a209f02171df%3A0x7a4c8d5d5ad7be56!2sMount%20Kilimanjaro!5e0!3m2!1sen!2s!4v1715805234567!5m2!1sen!2s",
        },
        gallery: [
            images.tour11Gallery1,
            images.tour11Gallery2,
            images.tour11Gallery3,
            images.tour11Gallery4,
            images.tour11Gallery5,
            images.tour11Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour11Review1,
                name: "James Carter",
                date: "July 15, 2024",
                rating: 5,
                content: "An unforgettable journey! The Kilimanjaro trek was challenging but rewarding, and the safari was a once-in-a-lifetime experience."
            },
            {
                id: 2,
                image: images.tour11Review2,
                name: "Sarah Blake",
                date: "July 20, 2024",
                rating: 4.9,
                content: "Great trek and amazing safari experience. The guides were professional, and I learned so much about Tanzania's wildlife."
            }
        ],
    },
    {
        id: 12,
        image: images.tour12,
        title: "Hiking Adventure",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Zion National Park",
            tourType: "Guided Hiking Tour",
            checkIn: "September 01, 2025",
            checkOut: "September 07, 2025",
            duration: "7 Days",
            person: "1 Person",
            price: 1000,
            minAge: "16 Years",
            maxAge: "65 Years",
            accommodation: "Campgrounds, Lodges",
            transportation: "Included",
            bestSeason: "Spring and Fall",
        },
        overviews: [
            "Hiking Adventure in Zion National Park is perfect for nature enthusiasts who enjoy rugged landscapes, towering cliffs, and thrilling hiking trails. This 7-day adventure will take you through Zion's iconic canyons, up to stunning viewpoints, and across challenging terrains. Get ready for breathtaking scenery and unforgettable memories."
        ],
        highlights: [
            "Hike the Iconic Angels Landing",
            "Explore the Narrows",
            "Guided Trekking through Zion Canyons",
            "Camping under the Stars",
            "Learn about Zion’s Geology and Flora"
        ],
        included: [
            "Guided Hiking Services",
            "Camping Equipment and Gear",
            "All Meals and Snacks",
            "Transportation to and from Zion National Park",
            "Entrance Fees to Zion National Park"
        ],
        excluded: [
            "Personal Hiking Gear",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive in Zion National Park and meet your guide for a full briefing on the tour ahead. Settle into your accommodation and prepare for the journey ahead.",
                activities: [
                    "Arrival and Transfer to Accommodation",
                    "Tour Briefing and Gear Check",
                    "Evening Welcome Dinner"
                ]
            },
            {
                day: "Day 2: Explore the Narrows",
                description: "Today, you’ll explore the Narrows, one of the most famous hikes in Zion National Park. Trek through the Virgin River and enjoy the stunning canyon walls.",
                activities: [
                    "Hike the Virgin River Narrows",
                    "Lunch along the River",
                    "Photography Stops at Scenic Points"
                ]
            },
            {
                day: "Day 3: Angels Landing Adventure",
                description: "Climb the famous Angels Landing trail. Known for its breathtaking views and thrilling switchbacks, this is one of the most iconic hikes in the world.",
                activities: [
                    "Morning Ascent to Angels Landing",
                    "Enjoy Panoramic Views",
                    "Descent and Return to Base"
                ]
            },
            {
                day: "Day 4: Canyon Overlook and Exploration",
                description: "Trek through Zion’s beautiful canyons. You'll explore the Canyon Overlook Trail and learn about the park’s unique geology and ecosystems.",
                activities: [
                    "Canyon Overlook Trail Hike",
                    "Geology Talk and Exploration",
                    "Return to Lodge for Evening Relaxation"
                ]
            },
            {
                day: "Day 5: Hidden Canyon and Riverside Walk",
                description: "Today’s hike takes you to the Hidden Canyon, followed by a relaxing Riverside Walk. Discover Zion’s hidden gems and tranquil river paths.",
                activities: [
                    "Hidden Canyon Hike",
                    "Relaxing Riverside Walk",
                    "Group Dinner and Campfire Gathering"
                ]
            },
            {
                day: "Day 6: Scenic Views and Free Time",
                description: "Take the day to relax, explore at your own pace, or join optional activities such as photography, bird watching, or additional hiking.",
                activities: [
                    "Optional Hiking or Photography",
                    "Leisure Time in the Park",
                    "Group Dinner and Farewell Party"
                ]
            },
            {
                day: "Day 7: Departure",
                description: "Pack up and bid farewell to Zion National Park. Transportation will be provided back to your departure point.",
                activities: [
                    "Morning Farewell Breakfast",
                    "Pack Up and Check Out",
                    "Return Transportation to Airport"
                ]
            }
        ],
        location: {
            description: "Embark on an exhilarating Hiking Adventure through some of the most stunning terrains. From rugged mountain paths to peaceful valleys, this journey offers a chance to connect with nature and challenge your hiking skills. Experience breathtaking vistas, diverse ecosystems, and a sense of accomplishment as you explore some of the most scenic trails. Whether you're a seasoned hiker or a beginner, this adventure provides an unforgettable outdoor experience for all levels of adventurers.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506888.3297748932!2d-113.0572867!3d37.1782916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c46a1e72f5e57%3A0x911c79d88e26fc64!2sZion%20National%20Park!5e0!3m2!1sen!2sus!4v1715805700000!5m2!1sen!2sus",
        },
        gallery: [
            images.tour12Gallery1,
            images.tour12Gallery2,
            images.tour12Gallery3,
            images.tour12Gallery4,
            images.tour12Gallery5,
            images.tour12Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour12Review1,
                name: "David Williams",
                date: "October 5, 2024",
                rating: 5,
                content: "The Hiking Adventure tour in Zion was incredible! The views were stunning, and the guide was knowledgeable and friendly. I can’t wait to return!"
            },
            {
                id: 2,
                image: images.tour12Review2,
                name: "Jessica Lee",
                date: "October 10, 2024",
                rating: 4.8,
                content: "A fantastic hiking experience! Zion is so beautiful, and the trails were challenging but rewarding. Highly recommend this tour to adventure seekers!"
            }
        ],
    },
    {
        id: 13,
        image: images.tour13,
        title: "Wildlife Expedition",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Yosemite Valley",
            tourType: "Guided Wildlife Expedition",
            checkIn: "June 15, 2025",
            checkOut: "June 22, 2025",
            duration: "8 Days",
            person: "1 Person",
            price: 1500,
            minAge: "12 Years",
            maxAge: "70 Years",
            accommodation: "Eco-lodges, Campsites",
            transportation: "Included",
            bestSeason: "Spring and Summer",
        },
        overviews: [
            "Embark on a thrilling Wildlife Expedition through Yosemite Valley! This 8-day guided tour takes you deep into the heart of Yosemite's wilderness, offering incredible opportunities to observe and photograph its diverse wildlife. From bears to birds, you'll experience nature up close while learning about the park’s rich ecology and wildlife conservation efforts."
        ],
        highlights: [
            "Wildlife Spotting and Photography",
            "Hiking in Yosemite’s Iconic Trails",
            "Learning from Expert Wildlife Guides",
            "Campsites and Eco-lodge Stays",
            "Evening Campfire Discussions"
        ],
        included: [
            "Expert Wildlife Guides",
            "All Transportation and Park Fees",
            "Accommodations (Eco-lodges and Campsites)",
            "Meals and Snacks",
            "Photography Support and Tips"
        ],
        excluded: [
            "Personal Gear (e.g. Camera, Binoculars)",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive in Yosemite Valley and meet your expert wildlife guide. After settling in, the group will have an orientation session to go over the tour itinerary, safety, and wildlife spotting techniques.",
                activities: [
                    "Arrival and Check-in",
                    "Tour Briefing and Orientation",
                    "Introduction to Yosemite’s Wildlife"
                ]
            },
            {
                day: "Day 2: Yosemite’s Scenic Trails and Wildlife Observation",
                description: "Explore Yosemite’s iconic trails, looking for signs of wildlife. Your guide will provide insight into the park’s ecosystems and teach you the best techniques for spotting and photographing animals in their natural habitat.",
                activities: [
                    "Morning Hike to Yosemite Falls",
                    "Wildlife Spotting Along the Trail",
                    "Photography Session with Wildlife"
                ]
            },
            {
                day: "Day 3: Exploring the Mariposa Grove",
                description: "Today, you’ll visit the Mariposa Grove of Giant Sequoias. Along the way, the group will look for wildlife in the meadows and forests surrounding the grove. Expect to encounter mule deer, squirrels, and a variety of birds.",
                activities: [
                    "Morning Hike to Mariposa Grove",
                    "Wildlife Spotting in Forested Areas",
                    "Group Photography at Sequoia Trees"
                ]
            },
            {
                day: "Day 4: Bird Watching and Photography Tips",
                description: "Bird watching enthusiasts will love today’s adventure, where you’ll learn how to identify Yosemite’s avian species. Your guide will provide tips on photography and how to capture animals in motion.",
                activities: [
                    "Bird Watching in Yosemite’s Meadows",
                    "Learning Bird Identification",
                    "Photography Tips and Techniques"
                ]
            },
            {
                day: "Day 5: Bear Spotting in Yosemite",
                description: "On this day, we’ll focus on spotting one of Yosemite’s most iconic animals: the black bear. Your guide will share information about bear behavior and the importance of wildlife conservation.",
                activities: [
                    "Bear Spotting Excursion",
                    "Educational Talk on Black Bears",
                    "Photography Session"
                ]
            },
            {
                day: "Day 6: Evening Campfire and Wildlife Talks",
                description: "After a day of wildlife exploration, the evening will be dedicated to campfire discussions. The guides will share fascinating stories about Yosemite’s wildlife and ecology.",
                activities: [
                    "Campfire Discussion on Yosemite’s Ecosystems",
                    "Wildlife Q&A with Guides",
                    "Star Gazing and Night Wildlife Sounds"
                ]
            },
            {
                day: "Day 7: Wildlife Conservation and Farewell",
                description: "Learn about ongoing wildlife conservation efforts in Yosemite. You’ll have the chance to speak with local experts and participate in a discussion about how you can help protect wildlife.",
                activities: [
                    "Wildlife Conservation Talk",
                    "Group Farewell and Reflections",
                    "Closing Photography Session"
                ]
            },
            {
                day: "Day 8: Departure",
                description: "After a farewell breakfast, we’ll depart Yosemite Valley. You’ll have one final opportunity to capture any last wildlife moments before heading home.",
                activities: [
                    "Final Wildlife Photography Session",
                    "Pack Up and Check Out",
                    "Return Transportation to Departure Point"
                ]
            }
        ],
        location: {
            description: "Set out on a thrilling Wildlife Expedition, where you’ll explore untamed landscapes and encounter some of the world’s most fascinating animals in their natural habitats. From dense jungles to vast savannas, this expedition offers close-up views of majestic wildlife, including big cats, elephants, and exotic birds. Perfect for nature lovers, photographers, and adventure seekers, the Wildlife Expedition immerses you in the beauty and raw power of the natural world.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.340689441532!2d-119.574233!3d37.7455701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096f1eeecae5a01%3A0x94f98d0eb5e6f59!2sYosemite%20Valley%2C%20CA%2095379%2C%20USA!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        },
        gallery: [
            images.tour13Gallery1,
            images.tour13Gallery2,
            images.tour13Gallery3,
            images.tour13Gallery4,
            images.tour13Gallery5,
            images.tour13Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour13Review1,
                name: "Sarah Miller",
                date: "July 12, 2025",
                rating: 5,
                content: "The Wildlife Expedition in Yosemite was absolutely amazing! I learned so much about the animals and the park. The guides were excellent, and the photography tips were invaluable!"
            },
            {
                id: 2,
                image: images.tour13Review2,
                name: "John Walker",
                date: "July 18, 2025",
                rating: 4.8,
                content: "An unforgettable experience! We saw so many animals and the hikes were beautiful. Highly recommend this tour to anyone interested in wildlife and photography."
            }
        ],
    },
    {
        id: 14,
        image: images.tour14,
        title: "Wilderness Exploration",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Rocky Mountain",
            tourType: "Guided Wilderness Exploration",
            checkIn: "July 10, 2025",
            checkOut: "July 17, 2025",
            duration: "8 Days",
            person: "1 Person",
            price: 1800,
            minAge: "15 Years",
            maxAge: "70 Years",
            accommodation: "Campsites, Eco-lodges",
            transportation: "Included",
            bestSeason: "Summer and Fall",
        },
        overviews: [
            "Join us on an incredible 8-day Wilderness Exploration through the majestic Rocky Mountains. This guided adventure immerses you in the stunning natural beauty of the region while you explore its rugged landscapes, wildlife, and pristine lakes. Whether you are an experienced trekker or a nature enthusiast, this tour offers something for everyone."
        ],
        highlights: [
            "Hiking Through Rugged Mountain Trails",
            "Camping in Secluded Wilderness Areas",
            "Exploration of High-altitude Lakes and Valleys",
            "Learning About Local Flora and Fauna",
            "Photography of Stunning Mountain Views"
        ],
        included: [
            "Expert Wilderness Guides",
            "All Camping Gear and Equipment",
            "Transportation to and from the Trailhead",
            "Meals and Snacks",
            "Safety and Emergency Support"
        ],
        excluded: [
            "Personal Gear (e.g. Hiking Boots, Camera)",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive at the trailhead and meet your guides. After a brief orientation session, you'll settle in and get ready for your first hike into the wilderness. The evening will include a campfire welcome dinner and an introduction to the exploration ahead.",
                activities: [
                    "Arrival and Check-in",
                    "Camp Setup and Orientation",
                    "Welcome Dinner and Briefing"
                ]
            },
            {
                day: "Day 2: Exploring Hidden Valleys",
                description: "Begin your exploration by hiking through the secluded valleys of the Rocky Mountains. This is a great opportunity to spot local wildlife, including elk and deer, while taking in the breathtaking scenery.",
                activities: [
                    "Hike Through Rocky Mountain Valleys",
                    "Wildlife Spotting",
                    "Picnic Lunch at a Scenic Spot",
                    "Evening Campfire Discussion"
                ]
            },
            {
                day: "Day 3: Summit Hike and Panoramic Views",
                description: "Today's adventure takes you to the top of one of the Rocky Mountains’ peaks. The climb may be challenging, but the panoramic views from the summit will be worth it. Afterward, descend to the campsite for a well-earned rest.",
                activities: [
                    "Morning Hike to the Summit",
                    "Panoramic Views of the Mountain Range",
                    "Summit Photography Session",
                    "Descent and Camp Setup"
                ]
            },
            {
                day: "Day 4: Glacier Exploration and Scenic Lakes",
                description: "Today you will explore the glaciers and high-altitude lakes that are scattered throughout the Rocky Mountains. The glaciers offer unique photo opportunities, and the lakes provide a peaceful environment to relax and enjoy nature.",
                activities: [
                    "Hike to Glacier Lakes",
                    "Photography of Glacial Landscapes",
                    "Relaxing by the High-altitude Lakes",
                    "Wildlife Observation"
                ]
            },
            {
                day: "Day 5: Wilderness Survival Skills",
                description: "In the heart of the wilderness, your guides will teach you essential survival skills, including fire-starting, shelter-building, and navigation. You'll also learn about the natural history and ecosystems of the Rocky Mountains.",
                activities: [
                    "Survival Skills Training",
                    "Building Emergency Shelters",
                    "Learning to Identify Local Flora and Fauna",
                    "Campfire Storytelling and Learning"
                ]
            },
            {
                day: "Day 6: Mountain Meadows and Exploration",
                description: "Explore the high-altitude meadows, home to wildflowers and wildlife. This area is known for its serene beauty and is a perfect place to photograph nature at its finest.",
                activities: [
                    "Hike Through Mountain Meadows",
                    "Wildflower Identification and Photography",
                    "Relaxing in Nature",
                    "Wildlife Spotting in the Meadows"
                ]
            },
            {
                day: "Day 7: Exploring the Alpine Tundra",
                description: "On this day, explore the alpine tundra, a harsh yet beautiful ecosystem where only the hardiest plants and animals survive. Your guides will explain the unique adaptations that enable life to thrive in these extreme conditions.",
                activities: [
                    "Hike Through the Alpine Tundra",
                    "Photography of the Tundra Landscape",
                    "Learning About Alpine Ecosystems"
                ]
            },
            {
                day: "Day 8: Return and Departure",
                description: "On your final day, you’ll pack up camp and begin your descent back to the trailhead. Afterward, we will provide transportation to your next destination or the airport.",
                activities: [
                    "Final Hike Back to Trailhead",
                    "Group Reflection and Farewell",
                    "Transportation to Departure Point"
                ]
            }
        ],
        location: {
            description: "Venture into the heart of untouched nature with our Wilderness Exploration. Discover remote landscapes, dense forests, and rugged terrains that are off the beaten path. This adventure offers the chance to reconnect with the wild, from serene lakes to towering peaks, all while testing your survival and exploration skills. Whether you're seeking solitude or an immersive adventure, the Wilderness Exploration provides a rare opportunity to experience the raw beauty of nature in its purest form.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.661706144226!2d-105.6836386!3d40.3427938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876961af214250d3%3A0x38c0b3f1e0535e60!2sRocky%20Mountain%20National%20Park!5e0!3m2!1sen!2sus!4v1715803654321!5m2!1sen!2sus",
        },
        gallery: [
            images.tour14Gallery1,
            images.tour14Gallery2,
            images.tour14Gallery3,
            images.tour14Gallery4,
            images.tour14Gallery5,
            images.tour14Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour14Review1,
                name: "Emily Watson",
                date: "August 1, 2025",
                rating: 5,
                content: "The Wilderness Exploration tour in Rocky Mountain was incredible! The views were breathtaking, and the survival skills session was so informative. Highly recommend this adventure!"
            },
            {
                id: 2,
                image: images.tour14Review2,
                name: "James Black",
                date: "August 5, 2025",
                rating: 4.9,
                content: "This was an unforgettable experience. The landscapes were out of this world, and the guides were knowledgeable. A perfect blend of adventure and nature!"
            }
        ],
    },
    {
        id: 15,
        image: images.tour15,
        title: "Snowshoeing Adventure",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Banff National Park",
            tourType: "Guided Snowshoeing Adventure",
            checkIn: "December 15, 2025",
            checkOut: "December 22, 2025",
            duration: "7 Days",
            person: "1 Person",
            price: 1200,
            minAge: "18 Years",
            maxAge: "70 Years",
            accommodation: "Mountain Lodges, Snowy Cabins",
            transportation: "Included",
            bestSeason: "Winter",
        },
        overviews: [
            "Join us on an exciting 7-day snowshoeing adventure through the breathtaking landscapes of Banff National Park. This guided tour offers an opportunity to experience winter in the Canadian Rockies, where you'll trek through snow-covered forests, frozen lakes, and majestic mountains. It's perfect for adventure seekers and nature lovers alike."
        ],
        highlights: [
            "Snowshoeing through Snow-covered Forests",
            "Exploring Frozen Lakes and Snowfields",
            "Stunning Views of Snow-capped Peaks",
            "Wildlife Spotting in the Winter Wilderness",
            "Learning Winter Survival Skills"
        ],
        included: [
            "Professional Snowshoeing Guides",
            "All Snowshoeing Equipment",
            "Meals and Snacks",
            "Winter Survival Training",
            "Transportation to and from Trailheads"
        ],
        excluded: [
            "Personal Snow Gear (e.g. Winter Boots, Jacket)",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive at the lodge and meet your guide for an orientation session. You'll get fitted with snowshoeing gear and have a chance to explore the surroundings before settling in for a cozy evening.",
                activities: [
                    "Check-in and Gear Fitting",
                    "Welcome Dinner",
                    "Orientation and Introduction to Snowshoeing"
                ]
            },
            {
                day: "Day 2: Snowshoeing Through Forests",
                description: "Today, you'll begin your snowshoeing journey through Banff's pristine forests. The trails will lead you through towering pines, offering fantastic opportunities to spot wildlife like elk and deer.",
                activities: [
                    "Guided Snowshoe Trek Through Forest Trails",
                    "Wildlife Spotting",
                    "Picnic Lunch in the Wilderness",
                    "Return to Lodge and Campfire Storytime"
                ]
            },
            {
                day: "Day 3: Frozen Lakes Exploration",
                description: "Head out to explore Banff's frozen lakes. This stunning winter landscape offers crystal-clear views of snow-capped peaks reflected on the icy surface. Take photos and enjoy some free time by the lakes.",
                activities: [
                    "Snowshoeing on Frozen Lakes",
                    "Photography of Scenic Views",
                    "Rest and Relaxation by the Ice"
                ]
            },
            {
                day: "Day 4: High-altitude Trekking",
                description: "Today, you'll tackle a more challenging high-altitude trail, which offers panoramic views of the snow-covered Rockies. The trail may be tough, but the sense of accomplishment and the views from the top are well worth it.",
                activities: [
                    "Morning Snowshoeing to a Mountain Ridge",
                    "Panoramic Views of the Rockies",
                    "Lunch at the Summit",
                    "Return to Lodge for Rest"
                ]
            },
            {
                day: "Day 5: Winter Survival Skills",
                description: "In this session, your guides will teach you winter survival skills, including how to build an emergency shelter, create a snow cave, and stay warm in the extreme cold of the Canadian wilderness.",
                activities: [
                    "Winter Survival Skills Workshop",
                    "Building Snow Shelters and Snow Caves",
                    "Fire-making Techniques in Snow"
                ]
            },
            {
                day: "Day 6: Snowshoeing to Scenic Vistas",
                description: "On Day 6, you'll trek through more remote areas of Banff National Park, reaching stunning vistas that offer sweeping views of the snow-covered terrain. It's a perfect day for photography and exploration.",
                activities: [
                    "Snowshoe Trek Through Remote Trails",
                    "Photography of Winter Landscapes",
                    "Lunch in a Scenic Spot"
                ]
            },
            {
                day: "Day 7: Return and Departure",
                description: "On the final day, after a hearty breakfast, you'll head back to the trailhead, concluding your snowshoeing adventure. You'll have time to freshen up and pack before departing for your next destination.",
                activities: [
                    "Final Snowshoe Trek Back to Lodge",
                    "Group Reflection and Farewell",
                    "Transportation to Departure Point"
                ]
            }
        ],
        location: {
            description: "Experience the winter wonderland like never before with our Snowshoeing Adventure. Trek through pristine snow-covered landscapes, navigating through forests, frozen lakes, and breathtaking mountain vistas. Whether you're a seasoned snowshoer or a first-time adventurer, this tour offers a unique way to explore the beauty of winter, with the tranquility of the snow underfoot and the crisp mountain air. Perfect for nature lovers and outdoor enthusiasts, the Snowshoeing Adventure promises an unforgettable winter experience.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102397.82925626156!2d-115.6764607!3d51.4968466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5378d4a54b5b3d91%3A0xa67d2f624eb18232!2sBanff%20National%20Park!5e0!3m2!1sen!2sca!4v1715804200000!5m2!1sen!2sca",
        },
        gallery: [
            images.tour15Gallery1,
            images.tour15Gallery2,
            images.tour15Gallery3,
            images.tour15Gallery4,
            images.tour15Gallery5,
            images.tour15Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour15Review1,
                name: "Sophia Harris",
                date: "January 10, 2026",
                rating: 5,
                content: "The Snowshoeing Adventure in Banff was absolutely magical! The winter landscapes were breathtaking, and the guides were fantastic. A must-do experience for any winter adventurer."
            },
            {
                id: 2,
                image: images.tour15Review2,
                name: "John Brown",
                date: "January 12, 2026",
                rating: 4.8,
                content: "This was an amazing experience! The winter survival skills workshop was so helpful, and the snowshoeing routes were gorgeous. Highly recommend it for nature lovers."
            }
        ],
    },
    {
        id: 16,
        image: images.tour16,
        title: "Glamping Experience",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Torres del Paine",
            tourType: "Guided Glamping Adventure",
            checkIn: "January 10, 2026",
            checkOut: "January 17, 2026",
            duration: "7 Days",
            person: "1 Person",
            price: 2000,
            minAge: "18 Years",
            maxAge: "70 Years",
            accommodation: "Luxury Glamping Tents",
            transportation: "Included",
            bestSeason: "Spring and Summer",
        },
        overviews: [
            "Experience the natural beauty of Torres del Paine with a luxurious twist! This 7-day glamping adventure combines the excitement of outdoor exploration with the comfort of high-end accommodations. You'll enjoy guided hikes, stunning views, and gourmet meals while staying in fully equipped luxury tents."
        ],
        highlights: [
            "Luxury Glamping in Fully Equipped Tents",
            "Guided Hikes to Iconic Landmarks",
            "Spectacular Views of Torres del Paine",
            "Gourmet Meals Prepared by Expert Chefs",
            "Relaxing Evenings by the Campfire"
        ],
        included: [
            "Professional Guides",
            "Luxury Glamping Tents with Beds and Private Bathrooms",
            "All Meals and Snacks",
            "Transportation to and from Torres del Paine",
            "All Necessary Hiking Gear"
        ],
        excluded: [
            "Personal Hiking Gear",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Activities",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Camp Setup",
                description: "Arrive at Torres del Paine and be transported to your luxury glamping site. After a welcome drink and briefing, you'll get settled in your fully equipped tent and enjoy your first gourmet dinner under the stars.",
                activities: [
                    "Check-in and Welcome Briefing",
                    "Get Settled in Luxury Glamping Tent",
                    "Gourmet Welcome Dinner"
                ]
            },
            {
                day: "Day 2: Hike to Base of the Towers",
                description: "Begin your exploration of Torres del Paine with a guided hike to the famous Base of the Towers. Along the way, you'll pass stunning landscapes and enjoy breathtaking views of the jagged peaks.",
                activities: [
                    "Guided Hike to Base of the Towers",
                    "Scenic Picnic Lunch",
                    "Return to Camp for Dinner and Relaxation"
                ]
            },
            {
                day: "Day 3: Lago Grey and Glacier View",
                description: "Today, you'll embark on a hike to Lago Grey, where you'll be able to see the impressive Grey Glacier. Capture incredible photos and enjoy a relaxing lunch with views of the glacier and lake.",
                activities: [
                    "Hike to Lago Grey",
                    "View of Grey Glacier and Icebergs",
                    "Lunch by Lago Grey",
                    "Return to Camp for Evening Entertainment"
                ]
            },
            {
                day: "Day 4: Scenic Exploration of the Patagonian Steppe",
                description: "Explore the Patagonian Steppe, home to unique flora and fauna. Your guide will teach you about the ecosystem and history of the region as you walk through this beautiful, wild terrain.",
                activities: [
                    "Scenic Walk through Patagonian Steppe",
                    "Wildlife Watching and Photography",
                    "Educational Talk about the Ecosystem",
                    "Dinner and Campfire Stories"
                ]
            },
            {
                day: "Day 5: Glamping Experience – Relax and Rejuvenate",
                description: "Take a break from hiking today to enjoy the luxury of your glamping accommodations. Relax with spa treatments, enjoy a gourmet brunch, or explore the nearby trails at your leisure.",
                activities: [
                    "Spa Treatments and Relaxation",
                    "Gourmet Brunch",
                    "Leisure Hike in Nearby Trails"
                ]
            },
            {
                day: "Day 6: Visit to Lago Sucia and the French Valley",
                description: "Hike to the stunning Lago Sucia, located at the base of the French Valley. The French Valley is known for its breathtaking beauty, including hanging glaciers, dramatic cliffs, and a turquoise lake.",
                activities: [
                    "Guided Hike to Lago Sucia and French Valley",
                    "Photography of Scenic Landscapes",
                    "Picnic Lunch by the Lake"
                ]
            },
            {
                day: "Day 7: Return and Departure",
                description: "After a farewell breakfast, you'll pack your things and return to the trailhead. Enjoy your last moments in Torres del Paine before being transported to your next destination.",
                activities: [
                    "Final Breakfast and Group Farewell",
                    "Packing and Departure"
                ]
            }
        ],
        location: {
            description: "Indulge in the ultimate blend of luxury and nature with our Glamping Experience. Enjoy the great outdoors without sacrificing comfort, as you stay in beautifully appointed tents or cabins surrounded by stunning landscapes. Whether you're nestled in the mountains, by a serene lake, or in the heart of the forest, glamping offers the perfect escape. Experience the tranquility of nature by day and the comfort of plush amenities by night. Ideal for those seeking adventure with a touch of luxury, this glamping experience provides a unique way to connect with the wild while enjoying all the comforts of home.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d802692.723936144!2d-73.3805186!3d-50.9423016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xbc4d93e332f1e7a7%3A0x46272f8986cb8f2b!2sTorres%20del%20Paine%20National%20Park!5e0!3m2!1sen!2scl!4v1715804720000!5m2!1sen!2scl",
        },
        gallery: [
            images.tour16Gallery1,
            images.tour16Gallery2,
            images.tour16Gallery3,
            images.tour16Gallery4,
            images.tour16Gallery5,
            images.tour16Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour16Review1,
                name: "Charlotte Evans",
                date: "February 20, 2026",
                rating: 5,
                content: "The Glamping Experience in Torres del Paine was incredible! The luxury tents were amazing, the food was fantastic, and the hikes were unforgettable. I felt like I was truly immersed in nature while being pampered. Highly recommend this tour!"
            },
            {
                id: 2,
                image: images.tour16Review2,
                name: "David Lee",
                date: "February 25, 2026",
                rating: 4.8,
                content: "A wonderful adventure! The guides were knowledgeable, and the scenery was beyond words. Glamping in Torres del Paine was the perfect blend of luxury and adventure. I would do it again in a heartbeat."
            }
        ],
    },
    {
        id: 17,
        image: images.tour17,
        title: "Cultural Climb",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Mount Kilimanjaro",
            tourType: "Cultural Trek",
            checkIn: "June 15, 2026",
            checkOut: "June 22, 2026",
            duration: "7 Days",
            person: "1 Person",
            price: 2500,
            minAge: "18 Years",
            maxAge: "65 Years",
            accommodation: "Mountain Huts and Campsites",
            transportation: "Included",
            bestSeason: "June to October",
        },
        overviews: [
            "The Cultural Climb on Mount Kilimanjaro is a unique journey that combines the challenge of summiting Africa’s highest peak with the opportunity to explore the local cultures of the region. This 7-day trek offers not only stunning views but also an immersion into the traditions and heritage of the Chagga people."
        ],
        highlights: [
            "Cultural Immersion with Local Tribes",
            "Scenic Trek through Rainforests and Alpine Deserts",
            "Summit of Mount Kilimanjaro",
            "Learn Traditional Chagga Cooking and Crafts",
            "Explore Local Villages and Markets"
        ],
        included: [
            "Professional Guides and Porters",
            "Cultural Immersion Experiences",
            "All Meals and Snacks",
            "Mountain Hut Accommodations",
            "Transportation to and from Kilimanjaro"
        ],
        excluded: [
            "Personal Hiking Gear",
            "Travel Insurance",
            "Personal Expenses",
            "Gratuities",
            "Optional Activities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Introduction to Kilimanjaro",
                description: "Arrive in Tanzania and transfer to your base camp near Mount Kilimanjaro. You'll be introduced to your guides and the porters, then participate in a cultural orientation session where you'll learn about the Chagga people and their traditions.",
                activities: [
                    "Arrival and Camp Setup",
                    "Cultural Orientation with Local Guides",
                    "Evening Dinner and Preparation"
                ]
            },
            {
                day: "Day 2: Begin Trekking – Rainforest Trek",
                description: "Start your trek through the lush rainforest slopes of Kilimanjaro, where you will enjoy the biodiversity of this unique environment. Learn about the local flora and fauna, as well as traditional uses of plants by the Chagga people.",
                activities: [
                    "Hike through Kilimanjaro’s Rainforest",
                    "Learn about Chagga’s Medicinal Plants",
                    "Arrive at First Camp and Settle In"
                ]
            },
            {
                day: "Day 3: Cultural Visit to Chagga Village",
                description: "Visit a traditional Chagga village and immerse yourself in the community. Participate in a cooking class, learn about local crafts, and engage in meaningful exchanges with the village members.",
                activities: [
                    "Visit Chagga Village",
                    "Traditional Cooking Class",
                    "Craft Demonstration and Hands-On Experience"
                ]
            },
            {
                day: "Day 4: Trek to the Alpine Desert Zone",
                description: "The trek continues as you ascend into the alpine desert zone. Experience breathtaking views of the surrounding landscape while learning about the geological history of Kilimanjaro and its role in shaping the region’s culture.",
                activities: [
                    "Hike Through Alpine Desert",
                    "Talk about Kilimanjaro’s Geological Formation",
                    "Settle in at High Altitude Camp"
                ]
            },
            {
                day: "Day 5: Cultural Exchange and Summit Preparation",
                description: "Take part in a cultural exchange session where you will meet with local elders and learn about the ancient traditions of the region. In the afternoon, you'll prepare for your summit push with final gear checks and an early night.",
                activities: [
                    "Cultural Exchange with Local Elders",
                    "Summit Preparation and Gear Checks",
                    "Early Night Rest"
                ]
            },
            {
                day: "Day 6: Summit Push to Uhuru Peak",
                description: "The summit day is here! Start early in the morning and make your way to the summit of Mount Kilimanjaro, Uhuru Peak. Celebrate your achievement with panoramic views and a sense of accomplishment.",
                activities: [
                    "Early Morning Summit Push",
                    "Reaching Uhuru Peak – Africa’s Highest Point",
                    "Celebratory Group Photos",
                    "Descent Back to Camp"
                ]
            },
            {
                day: "Day 7: Return and Departure",
                description: "After a well-deserved rest, descend back to the base camp. Enjoy a final meal together and reflect on the cultural experiences and physical challenge of the trek. You'll then be transferred back to your hotel in Moshi for departure.",
                activities: [
                    "Descent to Base Camp",
                    "Farewell Lunch and Group Reflection",
                    "Transfer Back to Moshi"
                ]
            }
        ],
        location: {
            description: "Embark on a fascinating Cultural Climb that blends physical adventure with rich cultural exploration. This journey takes you to awe-inspiring heights, where you’ll not only experience breathtaking views but also immerse yourself in the local traditions, history, and heritage of the region. As you ascend, learn about the unique customs, rituals, and stories that have shaped the local communities. Perfect for those seeking a meaningful adventure, the Cultural Climb offers a unique opportunity to connect with both nature and culture.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d315011.9092746883!2d37.3535434!3d-3.0758336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19d7a209f02171df%3A0x7a4c8d5d5ad7be56!2sMount%20Kilimanjaro!5e0!3m2!1sen!2s!4v1715805234567!5m2!1sen!2s",
        },
        gallery: [
            images.tour17Gallery1,
            images.tour17Gallery2,
            images.tour17Gallery3,
            images.tour17Gallery4,
            images.tour17Gallery5,
            images.tour17Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour17Review1,
                name: "John Smith",
                date: "June 25, 2026",
                rating: 5,
                content: "The Cultural Climb was more than just a trek. I learned so much about the Chagga culture and had a blast summiting Kilimanjaro. The guides were excellent and the cultural immersion was unforgettable."
            },
            {
                id: 2,
                image: images.tour17Review2,
                name: "Samantha Brown",
                date: "June 28, 2026",
                rating: 4.8,
                content: "An unforgettable experience! The trek itself was tough but rewarding, and the cultural interactions with the local people made the climb even more meaningful. Highly recommend this adventure!"
            }
        ],
    },
    {
        id: 18,
        image: images.tour18,
        title: "Night Photography",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit adipisicing.",
        details: {
            location: "Zion National Park",
            tourType: "Photography Tour",
            checkIn: "October 10, 2026",
            checkOut: "October 15, 2026",
            duration: "5 Days",
            person: "1 Person",
            price: 1200,
            minAge: "18 Years",
            maxAge: "65 Years",
            accommodation: "Lodges and Campsites",
            transportation: "Included",
            bestSeason: "Fall and Spring",
        },
        overviews: [
            "The Night Photography tour in Zion National Park offers an extraordinary opportunity to capture the stunning beauty of Zion under the stars. With expert guidance, you’ll learn night photography techniques while exploring one of the most iconic landscapes in the USA."
        ],
        highlights: [
            "Capture the Night Sky and Star Trails",
            "Learn Night Photography Techniques",
            "Explore Zion’s Iconic Rock Formations",
            "Enjoy Guided Sunset and Sunrise Sessions",
            "Photograph Wildlife in Low Light Conditions"
        ],
        included: [
            "Professional Photography Guide",
            "Transportation to and from Locations",
            "All Photography Gear (Optional)",
            "Meals and Snacks",
            "Access to Exclusive Locations"
        ],
        excluded: [
            "Personal Photography Equipment",
            "Travel Insurance",
            "Personal Expenses",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival and Orientation",
                description: "Arrive at Zion National Park, where you'll meet your photography guide and the group. After a brief orientation session about photography techniques and the park’s layout, you'll head to a prime location to capture your first sunset shots.",
                activities: [
                    "Arrival and Check-In at Lodge",
                    "Photography Orientation Session",
                    "Sunset Photography Session"
                ]
            },
            {
                day: "Day 2: Night Sky Photography",
                description: "This day will focus on capturing the night sky. After an afternoon hike through Zion’s breathtaking landscapes, you’ll set up for a night photography session to capture star trails and the Milky Way over the iconic rock formations.",
                activities: [
                    "Afternoon Scenic Hike",
                    "Night Sky Photography Workshop",
                    "Photograph Star Trails and Milky Way"
                ]
            },
            {
                day: "Day 3: Wildlife and Moonlight Photography",
                description: "Get up early for a sunrise shoot, followed by a day of wildlife photography under the moonlight. The focus will be on capturing the natural world in low light, including unique wildlife sightings and moonlit landscapes.",
                activities: [
                    "Sunrise Photography Shoot",
                    "Wildlife Photography in Low Light",
                    "Moonlight Landscape Photography Session"
                ]
            },
            {
                day: "Day 4: Advanced Night Photography Techniques",
                description: "Dive deeper into advanced photography techniques such as light painting and long exposure shots. Your guide will assist in refining your skills and help you capture the best shots of Zion’s rugged terrain under the night sky.",
                activities: [
                    "Light Painting Workshop",
                    "Advanced Long Exposure Photography",
                    "Night Photography Session in Zion’s Canyons"
                ]
            },
            {
                day: "Day 5: Final Shoot and Departure",
                description: "On the final day, you’ll have the opportunity to capture Zion’s landscapes one last time before the departure. Afterward, a group review session will allow you to showcase your best shots and receive feedback.",
                activities: [
                    "Final Photography Session",
                    "Group Photo Review and Feedback",
                    "Departure"
                ]
            }
        ],
        location: {
            description: "Capture the magic of the night with our Night Photography adventure. From starry skies to illuminated cityscapes, this experience will teach you how to master low-light conditions and enhance your skills in nighttime photography. Explore the beauty of the nocturnal world, whether it's the serene glow of moonlit landscapes or the vibrant energy of bustling streets. Perfect for photographers of all levels, this adventure offers the chance to create stunning, one-of-a-kind images that capture the essence of the night.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506888.3297748932!2d-113.0572867!3d37.1782916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c46a1e72f5e57%3A0x911c79d88e26fc64!2sZion%20National%20Park!5e0!3m2!1sen!2sus!4v1715805700000!5m2!1sen!2sus",
        },
        gallery: [
            images.tour18Gallery1,
            images.tour18Gallery2,
            images.tour18Gallery3,
            images.tour18Gallery4,
            images.tour18Gallery5,
            images.tour18Gallery6,
        ],
        comments: [
            {
                id: 1,
                image: images.tour18Review1,
                name: "David Lee",
                date: "October 18, 2026",
                rating: 5,
                content: "An incredible experience! The night sky photography was phenomenal. I learned so much about long exposure techniques and got to capture stunning shots of Zion’s starry sky."
            },
            {
                id: 2,
                image: images.tour18Review2,
                name: "Sophia Martinez",
                date: "October 20, 2026",
                rating: 4.9,
                content: "This tour was everything I hoped for and more. The guidance from the photographer was exceptional, and I left with amazing photos. Highly recommend for anyone interested in night photography."
            }
        ],
    }
];

export default tours;